function apply(data) {
  if (data.type === "CPS") {
    delete data.type;
    console.log(data);
    window.cps?.("event", data);
  }
}

export const trackOption = {
  onEvent(data) {
    Array.isArray(data) ? data.forEach(apply) : apply(data);
  },
};
